"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_client_1 = require("@tableau/analytics-client");
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetDatasourcesWithConnectabilityDetailsMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetDatasourcesWithConnectabilityDetailsMethod");
var IFilterClause_1 = require("@tableau/vizportal-webclient-api/lib/api/types/IFilterClause");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var reselect_1 = require("reselect");
var Localize_1 = require("../../gen-src/Localize");
var ConnectToDatabasesConnectionParamsQueryGql_1 = require("../queries/ConnectToDatabasesConnectionParamsQueryGql");
var ConnectToTablesConnectionParamsQueryGql_1 = require("../queries/ConnectToTablesConnectionParamsQueryGql");
var ConnectToDatabasesSortProvider_1 = require("../sorting/sortProviders/ConnectToDatabasesSortProvider");
var ConnectToDatasourcesSortProvider_1 = require("../sorting/sortProviders/ConnectToDatasourcesSortProvider");
var ConnectToTablesSortProvider_1 = require("../sorting/sortProviders/ConnectToTablesSortProvider");
var ConnectToDialogStyles_1 = require("../style/ConnectToDialogStyles");
var StyleFunctions_1 = require("../style/StyleFunctions");
var Logger_1 = require("../utils/Logger");
var SelectionProvider_1 = require("../wrappers/SelectionProvider");
var ConnectToDialogBottomPanel_1 = require("./ConnectToDialogBottomPanel");
var ConnectToDialogFunctions_1 = require("./ConnectToDialogFunctions");
var ConnectToTelemetryContext_1 = require("./ConnectToTelemetryContext");
var ConnectToDatabasesQueryGrid_1 = require("./QueryGrids/ConnectToDatabasesQueryGrid");
var ConnectToDatasourcesQueryGrid_1 = require("./QueryGrids/ConnectToDatasourcesQueryGrid");
var ConnectToTablesQueryGrid_1 = require("./QueryGrids/ConnectToTablesQueryGrid");
var ConnectToDialog = /** @class */ (function (_super) {
    __extends(ConnectToDialog, _super);
    function ConnectToDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.dataTypesForNoCatalog = [
            { value: 'Datasources', content: Localize_1.Messages.Datasources() }
        ];
        _this.dataTypesForExistingDS = [
            { value: 'Databases', content: Localize_1.Messages.DatabasesAndFiles() },
            { value: 'Tables', content: Localize_1.Messages.Tables() }
        ];
        _this.dataTypesForNewDS = [
            { value: 'Datasources', content: Localize_1.Messages.Datasources() },
            { value: 'Databases', content: Localize_1.Messages.DatabasesAndFiles() },
            { value: 'Tables', content: Localize_1.Messages.Tables() }
        ];
        _this.memoizedDataTypeListItems = reselect_1.defaultMemoize(function () {
            // workaround to hide datasources from viewer site roles
            if (!_this.state.roleAllowsViewingDatasources) {
                return (_this.state.isCatalogingEnabled && !_this.props.showDatasourceOnly) ? _this.dataTypesForExistingDS : [];
            }
            else if (_this.props.showDatasourceOnly || !_this.state.isCatalogingEnabled) {
                return _this.props.isNewDatasource ? _this.dataTypesForNoCatalog : [];
            }
            else {
                return _this.props.isNewDatasource ? _this.dataTypesForNewDS : _this.dataTypesForExistingDS;
            }
        });
        _this.onClosed = function () {
            return;
        };
        _this.onDataTypeChange = function (dataType) {
            _this.setState({ selectedDataType: dataType });
            _this.onClosed();
        };
        _this.clearSearch = function () {
            _this.setState({
                inProgressSearchText: '',
                querySearchText: ''
            });
        };
        _this.handleKeyDown = function (e, clearSelection) {
            if (e.key === 'Enter') {
                _this.sendSearchQuery(clearSelection);
            }
        };
        _this.updateSearchText = function (e) {
            _this.setState({ inProgressSearchText: e.target.value });
        };
        _this.sendSearchQuery = function (clearSelection) {
            if (clearSelection) {
                clearSelection();
            }
            _this.setState(function (prevState) {
                return {
                    querySearchText: _this.state.inProgressSearchText,
                    telemetryInfoNumSearches: prevState.telemetryInfoNumSearches + 1,
                };
            });
        };
        _this.onDatasetSelected = function (selectedKeys, client) { return function () { return __awaiter(_this, void 0, void 0, function () {
            var payload, connectionParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = new Map();
                        payload.set('actionType', 'onDatasetSelected');
                        payload.set('numSearches', this.state.telemetryInfoNumSearches.toString());
                        payload.set('selectedDataType', this.state.selectedDataType.toString());
                        return [4 /*yield*/, this.getConnectionParamsForSelectedRow(selectedKeys, client)];
                    case 1:
                        connectionParams = _a.sent();
                        if (connectionParams !== null) {
                            this.props.onDatasetSelected(connectionParams);
                            if (connectionParams.connectionType) {
                                payload.set('connectionType', connectionParams.connectionType.toString());
                            }
                            if (connectionParams.dataType) {
                                payload.set('dataType', connectionParams.dataType.toString());
                            }
                        }
                        this.emitConnectToTelemetry(payload);
                        return [2 /*return*/];
                }
            });
        }); }; };
        _this.getConnectionParamsForSelectedRow = function (selectedKeys, client) { return __awaiter(_this, void 0, void 0, function () {
            var selectedRowId, _a, data, selectedDatabase, getDatasources, slice, data, selectedTable;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        selectedRowId = Object.keys(selectedKeys)[0];
                        _a = this.state.selectedDataType;
                        switch (_a) {
                            case 'Databases': return [3 /*break*/, 1];
                            case 'Datasources': return [3 /*break*/, 3];
                            case 'Tables': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, client.query({
                            query: ConnectToDatabasesConnectionParamsQueryGql_1.ConnectToDatabasesConnectionParamsQueryGql,
                            variables: { databaseId: selectedRowId }
                        })];
                    case 2:
                        data = (_b.sent()).data;
                        selectedDatabase = data.databasesConnection.nodes[0];
                        return [2 /*return*/, ConnectToDialogFunctions_1.getConnectionParamsForDatabase(this.state.selectedDataType, selectedDatabase)];
                    case 3:
                        getDatasources = this.props.vizPortalWebClientRequester.createSender(GetDatasourcesWithConnectabilityDetailsMethod_1.GetDatasourcesWithConnectabilityDetailsMethod);
                        return [4 /*yield*/, getDatasources(new vizportal_webclient_api_1.GetItemsParams({
                                startIndex: 0,
                                maxItems: 1
                            }, {
                                clauses: [vizportal_webclient_api_1.Filter.stringFieldEq('repositoryUrl', selectedRowId), vizportal_webclient_api_1.Filter.fieldEq(IFilterClause_1.FilterFieldNames.isPublished, true)],
                                operator: IFilterClause_1.FilterOps.and
                            }))];
                    case 4:
                        slice = _b.sent();
                        return [2 /*return*/, (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(slice) && ConnectToDialogFunctions_1.isIGetDatasourcesResult(slice.response.result))
                                ? ConnectToDialogFunctions_1.getConnectionParamsForDatasource(slice.response.result)
                                : null];
                    case 5: return [4 /*yield*/, client.query({
                            query: ConnectToTablesConnectionParamsQueryGql_1.ConnectToTablesConnectionParamsQueryGql,
                            variables: { tableId: selectedRowId }
                        })];
                    case 6:
                        data = (_b.sent()).data;
                        selectedTable = data.databaseTablesConnection.nodes[0];
                        return [2 /*return*/, ConnectToDialogFunctions_1.getConnectionParamsForTable(this.state.selectedDataType, selectedTable)];
                    case 7: 
                    // This is practically unreachable as the connect button is disabled for no selection.
                    // We can't assert it however, as non-practical code paths lead here.
                    return [2 /*return*/, null];
                }
            });
        }); };
        _this.updateTotalRows = function (numberOfRows) {
            var payload = new Map();
            payload.set('actionType', 'updateTotalRows');
            payload.set('numRows', numberOfRows.toString());
            payload.set('selectedDataType', _this.state.selectedDataType.toString());
            _this.emitConnectToTelemetry(payload);
        };
        _this.state = {
            inProgressSearchText: '',
            isCatalogingEnabled: false,
            querySearchText: '',
            roleAllowsViewingDatasources: false,
            selectedDataType: 'NoSelection',
            telemetryInfoNumSearches: 0,
        };
        return _this;
    }
    ConnectToDialog.prototype.componentDidMount = function () {
        var _this = this;
        ConnectToDialogFunctions_1.getSessionInfo(this.props.vizPortalWebClientRequester).then(function (sInfo) {
            var isCatalogingEnabled = !!sInfo && !!sInfo.site.catalogingOnSiteEnabled;
            var roleAllowsViewingDatasources = _this.showDatasourcesBasedOnSiteRole(sInfo);
            var selectedDataType;
            if (roleAllowsViewingDatasources) {
                selectedDataType = _this.props.isNewDatasource ? 'Datasources' : isCatalogingEnabled ? 'Tables' : 'NoSelection';
            }
            else {
                selectedDataType = (isCatalogingEnabled && !_this.props.showDatasourceOnly) ? 'Tables' : 'NoSelection';
            }
            _this.setState(__assign({}, _this.state, { selectedDataType: selectedDataType, roleAllowsViewingDatasources: roleAllowsViewingDatasources, isCatalogingEnabled: isCatalogingEnabled }));
        }).catch(function (err) {
            Logger_1.Logger.error('GetSessionInfo did not succeed. Catalog will be unavailable.' + err);
        });
    };
    ConnectToDialog.prototype.getSelectedDataTypeString = function (dataType) {
        switch (dataType) {
            case 'Databases':
                return Localize_1.Messages.DatabasesAndFiles();
            case 'Datasources':
                return Localize_1.Messages.Datasources();
            case 'Tables':
                return Localize_1.Messages.Tables();
            default:
                return '';
        }
    };
    ConnectToDialog.prototype.emitConnectToTelemetry = function (payload) {
        if (this.props.telemetryContext != undefined) {
            if (this.props.telemetryContext.telemetryEnvironment != undefined &&
                this.props.telemetryContext.telemetryEnvironment !== ConnectToTelemetryContext_1.ConnectToTelemetryEnvironment.Disabled) {
                var reporter = new analytics_client_1.Reporter('https://analytics.tableausoftware.com');
                var eventBuilder = new analytics_client_1.AnalyticsEventFactory('ConnectToDialog', '', '');
                var payloadValue_1 = "appSessionId=" + this.props.telemetryContext.appSessionId + ";";
                payloadValue_1 += "dialogSessionId=" + this.props.telemetryContext.dialogSessionId + ";";
                payloadValue_1 += "machineId=" + this.props.telemetryContext.machineId + ";";
                payloadValue_1 += "telemetryEnvironment=" + this.props.telemetryContext.telemetryEnvironment + ";";
                payloadValue_1 += "dialogReleaseVersion=2019.4;";
                payload.forEach(function (value, key) {
                    payloadValue_1 = payloadValue_1.concat(key + "=" + value + ";");
                });
                var event_1 = eventBuilder.createEvent()
                    .ofType('connectToUsage')
                    .withProperty('payload', payloadValue_1)
                    .build();
                reporter.reportEvent(event_1);
            }
        }
    };
    ConnectToDialog.prototype.getDataTypeSelectionDropDown = function () {
        // Do not show the dropdown if we are showing only 1 or less dataType
        if (!this.state.isCatalogingEnabled || this.props.showDatasourceOnly) {
            return null;
        }
        // TODO: Better to move these and ToolBar to its own file
        var listProps = {
            items: this.memoizedDataTypeListItems(),
            onSelect: this.onDataTypeChange,
            selectOnEnterKey: true,
            selectedValue: this.state.selectedDataType,
            testId: 'connect-to-data-type-list',
        };
        return (React.createElement("div", { className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDropdown) },
            React.createElement(widgets_1.SingleSelectDropdown, { className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDropdownButton), type: widgets_1.DropdownButtonType.Line, list: React.createElement(widgets_1.List, __assign({}, listProps)), value: this.getSelectedDataTypeString(this.state.selectedDataType), onChange: this.onDataTypeChange, testId: 'connect-to-data-type-dropdown', stackingRootId: 'connect-to-dialog-tool-bar-stacking-root' }),
            React.createElement("span", { className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDropdownLabel) }, Localize_1.Messages.ConnectToDropdownLabelText())));
    };
    ConnectToDialog.prototype.showDatasourcesBasedOnSiteRole = function (sInfo) {
        var upperCaseRole = (!!sInfo ? sInfo.site.role : '').toUpperCase();
        return upperCaseRole !== 'VIEWER' && upperCaseRole !== 'UNLICENSED';
    };
    ConnectToDialog.prototype.renderGrid = function (selectedKeys, updateSelectionForKey) {
        var _this = this;
        switch (this.state.selectedDataType) {
            case 'Databases':
                return (React.createElement(react_apollo_1.ApolloConsumer, null, function (client) {
                    return React.createElement(ConnectToDatabasesSortProvider_1.ConnectToDatabasesGridSortProvider, null, function (_a) {
                        var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                        return React.createElement(ConnectToDatabasesQueryGrid_1.ConnectToDatabasesQueryGrid, { allowedClasses: _this.props.allowedClasses, apolloClient: client, orderBy: orderBy, searchText: _this.state.querySearchText, selectedKeys: selectedKeys, updateRowsCallback: _this.updateTotalRows, updateSelectionForKey: updateSelectionForKey, updateSortOrder: updateSortOrder });
                    });
                }));
            case 'Datasources':
                return (React.createElement(ConnectToDatasourcesSortProvider_1.ConnectToDatasourcesGridSortProvider, null, function (_a) {
                    var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                    return React.createElement(ConnectToDatasourcesQueryGrid_1.ConnectToDatasourcesQueryGrid, { orderBy: orderBy, searchText: _this.state.querySearchText, selectedKeys: selectedKeys, updateRowsCallback: _this.updateTotalRows, updateSelectionForKey: updateSelectionForKey, updateSortOrder: updateSortOrder, vizPortalWebClientRequester: _this.props.vizPortalWebClientRequester });
                }));
            case 'Tables':
                return (React.createElement(react_apollo_1.ApolloConsumer, null, function (client) {
                    return React.createElement(ConnectToTablesSortProvider_1.ConnectToTablesGridSortProvider, null, function (_a) {
                        var orderBy = _a.orderBy, updateSortOrder = _a.updateSortOrder;
                        return React.createElement(ConnectToTablesQueryGrid_1.ConnectToTablesQueryGrid, { allowedClasses: _this.props.allowedClasses, apolloClient: client, orderBy: orderBy, searchText: _this.state.querySearchText, selectedKeys: selectedKeys, updateRowsCallback: _this.updateTotalRows, updateSelectionForKey: updateSelectionForKey, updateSortOrder: updateSortOrder });
                    });
                }));
            default:
                return null;
        }
    };
    ConnectToDialog.prototype.render = function () {
        var _this = this;
        // Special styles needed for hybrid dialog (desktop) to work properly
        var connectToDialogContainerClassName = this.props.isDesktop
            ? StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogContainerForDesktop) : StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogContainerForWeb);
        var connectToDataGridClassName = this.props.isDesktop
            ? StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogGridContainerForDesktop) : StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogGridContainerForWeb);
        return (React.createElement(SelectionProvider_1.SingleSelectionProvider, { selectionId: this.state.selectedDataType }, function (_a) {
            var selectedKeys = _a.selectedKeys, updateSelectionForKey = _a.updateSelectionForKey, clearSelection = _a.clearSelection;
            return React.createElement("div", { className: connectToDialogContainerClassName },
                React.createElement("div", { className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogToolBar) },
                    React.createElement("div", { id: 'connect-to-dialog-tool-bar-stacking-root', className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogToolBarStackingRoot) }),
                    React.createElement(widgets_1.TextFieldWidget, { "aria-label": Localize_1.Messages.SearchLabel(), kind: 'search', label: '', onClear: _this.clearSearch, onChange: _this.updateSearchText, onKeyDown: function (e) { return _this.handleKeyDown(e, clearSelection); }, placeholder: Localize_1.Messages.SearchFieldPlaceholder(), style: ConnectToDialogStyles_1.ConnectToSearchFieldContainerStyle, testId: 'connect-to-search-field', value: _this.state.inProgressSearchText }),
                    _this.getDataTypeSelectionDropDown()),
                React.createElement("div", { className: connectToDataGridClassName },
                    React.createElement("div", { id: 'connect-to-dialog-data-grid-stacking-root', className: StyleFunctions_1.classes(ConnectToDialogStyles_1.ConnectToDialogDataGridStackingRoot) }),
                    _this.renderGrid(selectedKeys, updateSelectionForKey)),
                React.createElement(react_apollo_1.ApolloConsumer, null, function (client) {
                    return React.createElement(ConnectToDialogBottomPanel_1.ConnectToDialogBottomPanel, { allowedClasses: _this.props.allowedClasses, client: client, handleButtonClick: _this.onDatasetSelected(selectedKeys, client), selectedDataType: _this.state.selectedDataType, selectedRowIds: selectedKeys, vizPortalWebClientRequester: _this.props.vizPortalWebClientRequester });
                }));
        }));
    };
    return ConnectToDialog;
}(React.PureComponent));
exports.ConnectToDialog = ConnectToDialog;
//# sourceMappingURL=ConnectToDialog.js.map